export const Authendpoint = {
  loginApi: `/auth/login`,
  logout: `admin/log-out`,
};
